import { TenantPerformableFormProps } from '~/tenants/common/form';
import { MlmOrderContext } from '../../model/MlmOrder';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { MlmAerialType } from '~/tenants/mlm/performable/aerial/MlmAerialConfig';

export default function MlmAerialForm({}: TenantPerformableFormProps<MlmOrderContext>) {
  return (
    <ZodFieldSelect
      name="type"
      options={[
        { label: 'Photos', value: MlmAerialType.PHOTO },
        { label: 'Video', value: MlmAerialType.VIDEO },
        { label: 'Photos + Video', value: MlmAerialType.BOTH },
      ]}
    />
  );
}
